import type {
  ReportGroupsResponseBody,
  ReportsResponseBody,
} from '@ipfabric/utils';
import type { TableReports } from 'components/Table/model/TableModel';
import { createUrl } from 'utils/createUrl';
import type { ApiTableCommandFactory } from '../ApiTableModel';
import { selectTableId } from '../selectors/selectTableId';

export const loadTableReports: ApiTableCommandFactory =
  (cmdContext) => async () => {
    if (!cmdContext.getState().enableTableReports) {
      return;
    }
    const { snapshotId } = cmdContext.getState();
    const tableId = selectTableId(cmdContext.getState());

    if (!snapshotId) {
      return;
    }

    const [reportsResult, groups] = await Promise.all([
      cmdContext.api.request<ReportsResponseBody>({
        url: createUrl('/reports', {
          webEndpoint: tableId,
          snapshot: snapshotId,
        }),
      }),
      cmdContext.api.request<ReportGroupsResponseBody>({
        url: 'reports/groups',
      }),
    ]);

    const reports = reportsResult.reduce<TableReports>((acc, report) => {
      acc[report.column] = report;

      return acc;
    }, {});

    cmdContext.updateState((draft) => {
      draft.reports = reports;
      draft.groups = groups;
    });
  };
